import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import { Calculation, CalculationProps } from './calculation/calculation';

export interface UpgradeCalculationProps {
  data: CalculationProps[];
  status: LoadingState;
}

export const UpgradeCalculation = types
  .model({
    data: types.optional(types.array(Calculation), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: UpgradeCalculationProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
  }))
  .actions((self) => ({
    async setStore(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.upgrade.calculations,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setStore();
    },
    async update(): Promise<void> {
      await self.setStore();
    },
  }))
  .views((self) => ({
    getCalculations(): CalculationProps[] {
      const { data } = self;
      return [...getSnapshot(data)];
    },
  }));

export const upgradeCalculation = UpgradeCalculation.create();
export type UpgradeCalculationSnapshot = SnapshotIn<typeof UpgradeCalculation>;
export type UpgradeCalculationInstance = Instance<typeof UpgradeCalculation>;
export default upgradeCalculation;
